<template>
  <div class="cont">
    <div class="title">
      <div class="title_name"></div>
    </div>

    <div class="clear" style="margin-bottom:37px">
      <div class="img_cont img_cont_one clear" style="margin-right:37px" @click="gotoDetail('PD')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>

      <div class="img_cont img_cont_two clear" @click="gotoDetail('SD')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>

      <div class="img_cont img_cont_three clear" style="margin-top:40px;margin-right:37px" @click="gotoDetail('HD_HS')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>



      <div class="img_cont img_cont_five clear" style="margin-top:40px;" @click="gotoDetail('FP_FS')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>


      <div class="img_cont img_cont_seven clear" style="margin-top:40px;margin-right:37px" @click="gotoDetail('FC')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>

       <div class="img_cont img_cont_six clear" style="margin-top:40px;" @click="gotoDetail('twoPiece')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>


    </div>


  </div>
</template>

<script>
export default {
  name: "ContOne",
  data() {
    return {
      fit: "contain"
    };
  },
  methods: {
    gotoDetail( id ){
      // console.log( id )
      this.$router.push('/variousproducts/brakedisc/' + id )

    }
  }
};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  padding: 62px 73px;
  box-sizing: border-box;
  position relative
}

.clear:after {
  display: block;
  clear: both;
  content: '';
}

.title {
  position: absolute;
  width: 170px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/variousproducts/brakeDisc/imgt1.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 41px 42px 39px 42px;
  box-sizing: border-box;
}

.title_name {
  width: 86px;
  height: 28px;
  background: url('~@/assets/image/variousproducts/brakeDisc/imgt2.png');
  background-repeat: no-repeat;
  background-size: contain;
}


.img_cont {
  width: 410px;
  float: left;
  cursor pointer
}
  .img{
    background-repeat: no-repeat;
    background-size: contain;
    float: left;
  }
/* 对应 gotoDetail('PD') */
.img_cont_one
  .img_one{
    width: 20px;
    height: 106px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img1.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 88px;
    background: url('~@/assets/image/variousproducts/brakeDisc/PD.jpg');
    margin-right:6px;
  }
  .img_three{
    width: 53px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img3.png');
    margin-bottom:8px
  }
  .img_four{
    width: 241px;
    height: 70px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img4.png');
  }
  /* 对应 PD 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakeDisc/desc/PD.png');
    background-size: contain;

    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('SD') */
.img_cont_two
  .img_one{
    width: 20px;
    height: 106px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img5.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 88px;
    background: url('~@/assets/image/variousproducts/brakeDisc/SD.jpg');
    margin-right:6px;
  }
  .img_three{
    width: 52px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img7.png');
    margin-bottom: 9px
  }
  .img_four{
    width: 241px;
    height: 52px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img8.png');
  }
  /* 对应 SD 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakeDisc/desc/SD.png');
    background-size: contain;

    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('HD') */
.img_cont_three
  .img_one{
    width: 20px;
    height: 106px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img9.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 88px;
    background: url('~@/assets/image/variousproducts/brakeDisc/HD.HS.jpg');
    margin-right:6px;
  }
  .img_three{
    width: 60px;
    height: 22px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img11.png');
    margin-bottom: 9px
    background-size contain
  }
  .img_four{
    width: 238px;
    height: 52px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img12.png');
  }
  /* 对应 HD_HS 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakeDisc/desc/HD.HS.png');
    background-size: contain;

    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('HS') */
.img_cont_four
  .img_one{
    width: 20px;
    height: 106px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img13.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img14.png');
    margin-right:6px;
  }
  .img_three{
    width: 52px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img15.png');
    margin-bottom: 9px
  }
  .img_four{
    width: 241px;
    height: 52px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img16.png');
  }
  /* 对应 HS 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakeDisc/desc/HD.HS.png');
    background-size: contain;

    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('FP_FS') */
.img_cont_five
  .img_one{
    width: 20px;
    height: 106px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img17.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 88px;
    background: url('~@/assets/image/variousproducts/brakeDisc/FP.FS.jpg');
    margin-right:6px;
  }
  .img_three{
    width: 79px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img19.png');
    margin-bottom: 9px
  }
  .img_four{
    width: 241px;
    height: 70px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img20.png');
  }
  /* 对应 FP_FS 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakeDisc/desc/FP.FS.png');
    background-size: contain;

    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('twoPiece') */
.img_cont_six
  .img_one{
    width: 20px;
    height: 106px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img21.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/2P.jpg');
    margin-right:6px;
  }
  .img_three{
    width: 171px;
    height: 23px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img23.png');
    margin-bottom: 8px
  }
  .img_four{
    width: 221px;
    height: 70px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img24.png');
  }
  /* 对应 twoPiece 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakeDisc/desc/2P.png');
    background-size: contain;

    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('FC') */
.img_cont_seven
  .img_one{
    width: 20px;
    height: 106px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img21.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 88px;
    background: url('~@/assets/image/variousproducts/brakeDisc/FC.jpg');
    margin-right:6px;
  }
  .img_three{
    width: 49px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img26.png');
    margin-bottom: 8px
  }
  .img_four{
    width: 240px;
    height: 70px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img27.png');
  }
  /* 对应 FC 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakeDisc/desc/FC.png');
    background-size: contain;

    background-repeat: no-repeat;
  }

</style>
